<ng-container *transloco="let t; read: 'layout'">

  <mat-sidenav-container [hasBackdrop]="handset">
    <mat-sidenav #sidenav mode="side" [(opened)]="opened">

      <header>
        <div class="logo-alternative-medium" (click)="redirect()"></div>
      </header>

      <!-- MAIN NAVIGATION -->
      <navigation-tree [navigationTree]="trees"></navigation-tree>

      <!-- SECONDARY NAVIGATION -->

      <span class="colflex"></span>

      <div class="footer-container">
        <div class="footer-content">
          <!-- FOOTER NAVIGATION -->
          <div class="legal">
            <a href="https://www.olfeo.com/fr/mentions-legales" target="_BLANK" rel="noopener noreferrer">{{ t('navigation.footer.legal') }}</a>
            <a href="https://www.olfeo.com/contrats-et-cgv/" target="_BLANK" rel="noopener noreferrer">{{ t('navigation.footer.license') }}</a>
          </div>
        </div>
        <span>&copy;&nbsp;{{t('copyright', {year: copyrightYear, version: version.app})}}</span>
      </div>
    </mat-sidenav>

    <!-- MAIN ROUTER OUTLET -->
    <mat-sidenav-content>
      <mat-toolbar>
        <button mat-icon-button (click)="sidenav.toggle()" *ngIf="!sidenav.opened">
          <mat-icon color="primary">menu</mat-icon>
        </button>

        <span [ngClass]="{'flex': handset}"></span>

        <breadcrumb></breadcrumb>

        <span [ngClass]="{'flex': !handset}"></span>

        <div class="row">
          <contextual-help></contextual-help>
          <span class="separator"></span>
          <div class="account-container">
            <account [admin]="adminMe"></account>
          </div>
        </div>
      </mat-toolbar>
<!--
      <div class="row deprecation-alert" *ngIf="isDeprecated">
        <div class="column">
          <span>{{ t('deprecated.message') }}</span>
          <div class="row">
            <span>{{ t('deprecated.date') }}</span>&nbsp;
            <a href="https://awareness.olfeo.eu/" target="_blank">Olfeo Awareness</a>&nbsp;
            <span>{{ t('deprecated.after-link') }}</span>
          </div>
        </div>
        <div class="dismiss">
          <button mat-icon-button (click)="dismiss()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div> -->

      <div class="router-outlet">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>
